import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import media from 'styles/media'

const SecureOpnCreditCard = () => {
  const { t } = useTranslation()

  return (
    <SecurePaymentContainer>
      <SecurePaymentWrapper>
        <SecurePaymentText>{t('paymentMethodPage.secureCreditCardPayment.headerTxt')}</SecurePaymentText>
        <SecurePaymentLogos>
          <img src={`${process.env.PUBLIC_URL}/assets/payment/visa.svg`} alt="icon-visa-card" />
          <img src={`${process.env.PUBLIC_URL}/assets/payment/master-card.svg`} alt="icon-master-card" />
          <img style={{ height: '24px' }} src={`${process.env.PUBLIC_URL}/assets/payment/jcb.svg`} alt="icon-jcb" />
          <img
            className="omise-logo"
            src={`${process.env.PUBLIC_URL}/assets/payment/omise-logo-dark.png`}
            alt="omise-logo-dark"
          />
        </SecurePaymentLogos>
      </SecurePaymentWrapper>
      <SecuredPaymentDescription>
        {t('paymentMethodPage.secureCreditCardPayment.descriptionLine1')} <br />
        {t('paymentMethodPage.secureCreditCardPayment.descriptionLine2')}
      </SecuredPaymentDescription>
    </SecurePaymentContainer>
  )
}

export default SecureOpnCreditCard

const SecurePaymentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.veryLightGrey};
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  margin-bottom: 20px;

  @media (${media.screenSmMiniMax}) {
    padding: 8px;
  }
`

const SecurePaymentText = styled.div`
  font-size: 10px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.gray600};
  position: relative;
  top: 5px;
`

const SecurePaymentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 18px;

  @media (${media.screenSmMin}) {
    justify-content: center;
  }

  @media (${media.screenSmMiniMax}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
  }
`

const SecurePaymentLogos = styled.div`
  img {
    margin-right: 4px;
    alt: 'Secure payment logo';

    &.omise-logo {
      height: 14px;
    }
  }
`

const SecuredPaymentDescription = styled.div`
  color: ${({ theme }) => theme.colors.base};
  font-size: 12px;
  margin-top: 20px;
  line-height: 1.5;
  font-weight: 600;
  text-align: start;

  @media (${media.screenSmMin}) {
    text-align: center;
  }

  @media (${media.screenSmMiniMax}) {
    font-size: 10px;
    text-align: center;
  }
`
